import React from "react";

export const SHAPE_SIZE = {
  landscape: { w: 28, h: 20 },
  square: { w: 22, h: 22 },
  portrait: { w: 18, h: 24 },
  tall: { w: 16, h: 28 },
  ultrawide: { w: 30, h: 14 },
};

/**
 * Snap W×H to the same discrete shapes AI Expand uses (landscape / square / portrait / tall / ultrawide).
 */
export function shapeFromAspect(width, height, aspectRatio) {
  const w = Number(width);
  const h = Number(height);
  let ratio = null;
  if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) {
    ratio = w / h;
  } else if (aspectRatio && String(aspectRatio).includes(":")) {
    const [a, b] = String(aspectRatio).split(":").map(Number);
    if (a > 0 && b > 0) ratio = a / b;
  }
  if (ratio == null || !Number.isFinite(ratio)) return "landscape";
  if (Math.abs(ratio - 1) < 0.08) return "square";
  if (ratio >= 2.1) return "ultrawide";
  if (ratio >= 1) return "landscape";
  if (ratio <= 0.62) return "tall";
  return "portrait";
}

/**
 * Mini aspect-frame icon — same geometry as AI Expand aspect cards when using `shape`.
 */
export default function AspectShapeIcon({
  shape = "landscape",
  width,
  height,
  aspectRatio,
  size = 36,
  className,
}) {
  const resolvedShape =
    shape && SHAPE_SIZE[shape]
      ? shape
      : shapeFromAspect(width, height, aspectRatio);
  const dims = SHAPE_SIZE[resolvedShape] || SHAPE_SIZE.landscape;
  const padX = (size - dims.w) / 2;
  const padY = (size - dims.h) / 2;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      aria-hidden="true"
    >
      <rect
        x={padX}
        y={padY}
        width={dims.w}
        height={dims.h}
        rx="2.5"
        fill="currentColor"
        opacity="0.1"
      />
      <rect
        x={padX}
        y={padY}
        width={dims.w}
        height={dims.h}
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1"
      />
    </svg>
  );
}
